const HorizontalAlignment ={
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center'
}

export default HorizontalAlignment
